import Layout from "containers/Layout";
import {Switch, Route, Redirect} from "react-router-dom";
import {useSelector} from "react-redux";
import {selectAuth} from "../containers/SingIn/authSlice";
import SupersetView from "../components/Superset";
import {NavItem} from "../containers/SingIn/types";

const MainApp = () => {
  const {dashboard_menu_items} = useSelector(selectAuth);
  return (
    <Layout>
      <Switch>
        <Route exact path="/">
          <Redirect
              to={{
                pathname: `/${dashboard_menu_items[0]?.slug}`,
                state: { menu_item: dashboard_menu_items[0] },
              }}
          />
        </Route>
          {dashboard_menu_items.flatMap((item: NavItem) => {
              const routes = [
                  <Route
                      key={item.slug}
                      path={`/${item.slug}`}
                      component={item.component ?? SupersetView}
                  />,
              ];

              if (item.sub_dashboards?.length) {
                  const subRoutes = item.sub_dashboards.map((subItem: NavItem) => (
                      <Route
                          key={subItem.id}
                          path={`/${subItem.slug}`}
                          component={subItem.component ?? SupersetView}
                      />
                  ));
                  routes.push(...subRoutes);
              }

              return routes;
          })}
      </Switch>
    </Layout>
  )
};
export default MainApp;